import { useMutation } from "@tanstack/react-query";
import { uploadGalleryImage } from "./gallery.service";

export const useUploadGalleryImageMutation = () => {
  return useMutation({
    mutationFn: (payload) => uploadGalleryImage(payload),
  });
};
